import { render, staticRenderFns } from "./NoticeContainer.vue?vue&type=template&id=55ce88d8"
import script from "./NoticeContainer.vue?vue&type=script&lang=js"
export * from "./NoticeContainer.vue?vue&type=script&lang=js"
import style0 from "./NoticeContainer.vue?vue&type=style&index=0&id=55ce88d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports